// extracted by mini-css-extract-plugin
export default {"cardService":"ServiceCard_cardService__9KtKw","imageDiv":"ServiceCard_imageDiv__OQlz9","detailDiv":"ServiceCard_detailDiv__Gptz3"};